// BSC Slider JavaScript - Exact Slide Effect Match
(function() {
  'use strict';
  
  function initSlider(sliderElement) {
    if (!sliderElement) return;
    
    const slidesContainer = sliderElement.querySelector('.bsc-slides');
    const slides = sliderElement.querySelectorAll('.bsc-slide');
    const dots = sliderElement.querySelectorAll('.bsc-dot');
    const prevBtn = sliderElement.querySelector('.bsc-arrow-prev');
    const nextBtn = sliderElement.querySelector('.bsc-arrow-next');
    
    if (!slidesContainer || slides.length === 0) return;
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    const autoplay = sliderElement.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(sliderElement.getAttribute('data-autoplay-speed')) || 5000;
    const fadeEffect = sliderElement.getAttribute('data-fade') === 'true';
    let autoplayInterval = null;
    let slideWidth = 100; // 100% width per slide
    
    // Set initial slider width
    slidesContainer.style.width = (totalSlides * 100) + '%';
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.width = slideWidth + '%';
    }
    
    function updateSlider() {
      if (fadeEffect) {
        // Fade effect
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.opacity = i === currentSlide ? '1' : '0';
          slides[i].style.transition = 'opacity 0.5s ease-in-out';
        }
      } else {
        // Slide effect - exact match
        const translateX = -currentSlide * slideWidth;
        slidesContainer.style.transform = 'translateX(' + translateX + '%)';
      }
      
      // Update dots - exact match with original classes
      for (let i = 0; i < dots.length; i++) {
        if (i === currentSlide) {
          dots[i].classList.add('bsc-dot-active');
        } else {
          dots[i].classList.remove('bsc-dot-active');
        }
      }
      
      // Update active slide class - exact match
      for (let i = 0; i < slides.length; i++) {
        if (i === currentSlide) {
          slides[i].classList.add('bsc-active');
        } else {
          slides[i].classList.remove('bsc-active');
        }
      }
    }
    
    function nextSlide() {
      currentSlide = (currentSlide + 1) % totalSlides;
      updateSlider();
    }
    
    function prevSlide() {
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
      updateSlider();
    }
    
    function goToSlide(index) {
      if (index >= 0 && index < totalSlides) {
        currentSlide = index;
        updateSlider();
      }
    }
    
    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        nextSlide();
        resetAutoplay();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prevSlide();
        resetAutoplay();
      });
    }
    
    // Dots event listeners
    for (let i = 0; i < dots.length; i++) {
      const button = dots[i].querySelector('button');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          goToSlide(i);
          resetAutoplay();
        });
      }
    }
    
    // Autoplay functionality
    function startAutoplay() {
      if (autoplay && totalSlides > 1) {
        autoplayInterval = setInterval(function() {
          nextSlide();
        }, autoplaySpeed);
      }
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    function resetAutoplay() {
      stopAutoplay();
      setTimeout(function() {
        startAutoplay();
      }, 100);
    }
    
    // Pause on hover
    sliderElement.addEventListener('mouseenter', function() {
      stopAutoplay();
    });
    
    sliderElement.addEventListener('mouseleave', function() {
      startAutoplay();
    });
    
    // Touch support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    sliderElement.addEventListener('touchstart', function(e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchStartX = e.changedTouches[0].screenX;
      }
    });
    
    sliderElement.addEventListener('touchend', function(e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }
    });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        resetAutoplay();
      }
    }
    
    // Resize handler
    function handleResize() {
      updateSlider();
    }
    
    window.addEventListener('resize', handleResize);
    
    // Initialize - exact match with fade effect setup
    if (fadeEffect) {
      slidesContainer.style.display = 'block';
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.position = 'absolute';
        slides[i].style.top = '0';
        slides[i].style.left = '0';
        slides[i].style.width = '100%';
        slides[i].style.opacity = i === 0 ? '1' : '0';
      }
    }
    
    updateSlider();
    startAutoplay();
    
    // Return cleanup function
    return function cleanup() {
      stopAutoplay();
      window.removeEventListener('resize', handleResize);
    };
  }
  
  // Store initialized sliders
  const initializedSliders = new Map();
  
  // Initialize all sliders
  function initAllSliders() {
    const sliders = document.querySelectorAll('.bsc-slider');
    
    for (let i = 0; i < sliders.length; i++) {
      const slider = sliders[i];
      const sliderId = slider.closest('[data-section-id]')?.getAttribute('data-section-id') || 'slider-' + i;
      
      // Clean up existing slider if any
      if (initializedSliders.has(sliderId)) {
        const cleanup = initializedSliders.get(sliderId);
        if (typeof cleanup === 'function') {
          cleanup();
        }
      }
      
      // Initialize new slider
      const cleanup = initSlider(slider);
      if (cleanup) {
        initializedSliders.set(sliderId, cleanup);
      }
    }
  }
  
  // DOM ready check
  function domReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }
  
  // Initialize on DOM ready
  domReady(function() {
    initAllSliders();
  });
  
  // Shopify section reloading
  document.addEventListener('shopify:section:load', function(event) {
    if (event && event.target) {
      const slider = event.target.querySelector('.bsc-slider');
      if (slider) {
        setTimeout(function() {
          initSlider(slider);
        }, 100);
      }
    }
  });
  
  // Handle section unload
  document.addEventListener('shopify:section:unload', function(event) {
    if (event && event.target) {
      const sectionId = event.target.getAttribute('data-section-id');
      if (sectionId && initializedSliders.has(sectionId)) {
        const cleanup = initializedSliders.get(sectionId);
        if (typeof cleanup === 'function') {
          cleanup();
        }
        initializedSliders.delete(sectionId);
      }
    }
  });
  
  // Expose global function for manual initialization
  window.BSCSlider = {
    init: initAllSliders,
    initSingle: initSlider
  };
  
})();